export default __webpack_public_path__ + "static/media/tin_can.249ae246.png";